<div class="px-5 py-8 min-w-[250px] max-w-[95vw] sm:max-w-[500px] relative rounded bg-white shadow-lg">
	<div (click)="onClose()" class="absolute top-1 right-2">
			<span class="material-symbols-outlined cursor-pointer">
				close
			</span>
	</div>
	<div class="w-full justify-center items-center flex flex-col">
		<h1 class="text-base md:text-xl p-1 font-medium">Are you sure you want to cancel this order?</h1>
		<h3 class="text-sm text-[#9fa6b8] p-2 ">Order Id: #{{data.orderId}}</h3>
		<div class="text-base py-2 text-center">Please specify the reason for cancellation</div>
		<input class="p-2 my-2 w-full border-2 border-[#9fa6b8] rounded" type="text"
			   placeholder="Cancellation Reason"
			   [(ngModel)]="reason">
		<div *ngIf="showError"
			 class="text-xs text-red-500 py-2 text-center">Cancellation reason is required</div>

		<div class="flex justify-end items-center gap-0.5 my-1">
			<button (click)="onSubmit()"
					class="text-white transition-all bg-[#88755e] py-1.5 px-5 w-max hover:bg-[#734e1f] flex justify-center items-center rounded-md">Cancel Order</button>
		</div>
	</div>
</div>
